import {FloorPlan, Lead, Settings} from "./SharedTypes";

export default class BackendApi {
    baseUrl: string;
    nonce: string;

    constructor(baseUrl: string, nonce: string) {
        this.baseUrl = baseUrl;
        this.nonce = nonce;
    }

/*    async getUser(): Promise<WP_REST_API_User> {
        return fetch(`${this.baseUrl}/wp/v2/users/me?_wpnonce=${this.nonce}`, {
            headers: {'accept': 'application/json'},
            credentials: 'include',
        }).then(r => r.json());
    }*/

    async findFloorPlan(name: string): Promise<FloorPlan | undefined> {
        return await fetch(`${this.baseUrl}/home-options-picker/v1/floor-plans?name=${encodeURIComponent(name)}`, {
            headers: {'content-type': 'application/json'},
        }).then(r => r.json()).then(floorPlans => floorPlans?.[0]);
    }

    async findFloorPlanById(id: string): Promise<FloorPlan | undefined> {
        return await fetch(`${this.baseUrl}/home-options-picker/v1/floor-plans?id=${id}`, {
            headers: {'content-type': 'application/json'},
        }).then(r => r.json()).then(floorPlans => floorPlans?.[0]);
    }

    async listFloorPlans(): Promise<FloorPlan[]> {
        return await fetch(`${this.baseUrl}/home-options-picker/v1/floor-plans`, {
            headers: {'content-type': 'application/json'},
        }).then(r => r.json());
    }

    async createFloorPlan(floorPlan: FloorPlan, importImages?: boolean): Promise<void> {
        await fetch(`${this.baseUrl}/home-options-picker/v1/floor-plans?_wpnonce=${this.nonce}`, {
            method: 'POST',
            headers: {'content-type': 'application/json'},
            body: JSON.stringify({...floorPlan, importImages})
        });
    }

    async updateFloorPlan(floorPlan: FloorPlan): Promise<void> {
        await fetch(`${this.baseUrl}/home-options-picker/v1/floor-plans?_wpnonce=${this.nonce}`, {
            method: 'PATCH',
            headers: {'content-type': 'application/json'},
            body: JSON.stringify(floorPlan)
        });
    }

    async deleteFloorPlan(id: number): Promise<void> {
        await fetch(`${this.baseUrl}/home-options-picker/v1/floor-plans/${id}?_wpnonce=${this.nonce}`, {
            method: 'DELETE',
        });
    }

    async getFloorPlanOrder(): Promise<number[]> {
        return await fetch(`${this.baseUrl}/home-options-picker/v1/floor-plan-order`, {
            headers: {'content-type': 'application/json'},
        }).then(r => r.json());
    }

    async updateFloorPlanOrder(order:number[]): Promise<void> {
        await fetch(`${this.baseUrl}/home-options-picker/v1/floor-plan-order?_wpnonce=${this.nonce}`, {
            method: 'PUT',
            headers: {'content-type': 'application/json'},
            body: JSON.stringify({order})
        });
    }

    async submitLead(options: any, name: string, email: string, phone: string, floorPlanId: string, floorPlanName: string): Promise<{url: string}> {
        const body = new FormData();
        body.append('file', options);
        body.append('name', name);
        body.append('email', email);
        body.append('phone', phone);
        body.append('floorPlanName', floorPlanName);
        body.append('floorPlanId', floorPlanId);
        return await fetch(`${this.baseUrl}/home-options-picker/v1/leads`, {
            method: 'POST', body
        }).then(r => r.json());
    }

    async encodeImage(url: string): Promise<string> {
        return await fetch(`${this.baseUrl}/home-options-picker/v1/encode-image?url=${encodeURIComponent(url)}`, {
            method: 'GET',
        }).then(r => r.json()).then((result:any) => result.encoded);
    }

    async getSettings(): Promise<Settings> {
        return await fetch(`${this.baseUrl}/home-options-picker/v1/settings?${this.nonce ? `_wpnonce=${this.nonce}` : ''}`, {
            method: 'GET',
        }).then(r => r.json());
    }

    async saveSettings(settings: Settings): Promise<void> {
        await fetch(`${this.baseUrl}/home-options-picker/v1/settings?_wpnonce=${this.nonce}`, {
            method: 'PATCH', headers: {'content-type': 'application/json'},
            body: JSON.stringify(settings)
        });
    }

    async listLeads(): Promise<Lead[]> {
        return await fetch(`${this.baseUrl}/home-options-picker/v1/leads?_wpnonce=${this.nonce}`, {
            method: 'GET',
        }).then(r => r.json());
    }

    async updateLead(lead: Lead): Promise<void> {
        await fetch(`${this.baseUrl}/home-options-picker/v1/leads?_wpnonce=${this.nonce}`, {
            method: 'PATCH',
            headers: {'content-type': 'application/json'},
            body: JSON.stringify(lead),
        });
    }

    async deleteLead(leadId: number): Promise<void> {
        await fetch(`${this.baseUrl}/home-options-picker/v1/leads/${leadId}?_wpnonce=${this.nonce}`, {
            method: 'DELETE',
        });
    }

    async getSalesTax(zip: string): Promise<any> {
        return await fetch(`${this.baseUrl}/home-options-picker/v1/sales-tax?_wpnonce=${this.nonce}&zip=${encodeURIComponent(zip)}`, {
            method: 'GET',
        }).then(r => r.json());
    }
}